import { Link } from 'react-router-dom';
import { Card } from '@heroui/react';

import { useDocumentTitle } from '../../services/pageTitle';
import logo from '../../assets/img/logo/logo.svg';
import bckImg from '../../assets/img/login-page.jpg';

// Το κοινό κέλυφος των τεσσάρων οθονών ταυτοποίησης: σύνδεση, εγγραφή,
// επαναφορά κωδικού, ορισμός νέου κωδικού.
//
// Στο πρότυπο του 2019 οι τέσσερις οθόνες επαναλάμβαναν το ίδιο πλέγμα Bootstrap
// με διαφορετικά `offset` ανά breakpoint, τη φωτογραφία φόντου, το λογότυπο και
// τον υποσέλιδο σύνδεσμο. Τέσσερα αντίγραφα σημαίνει ότι μια διόρθωση σε μία
// οθόνη δεν φτάνει στις άλλες τρεις: η οθόνη επαναφοράς είχε πλάτος 4 στηλών και
// η εγγραφή 6, χωρίς κανέναν λόγο.
//
// Η φωτογραφία φόντου σκουραίνει με επίστρωση, ώστε η κάρτα να έχει αντίθεση
// ανεξάρτητα από το τι δείχνει η φωτογραφία. Χωρίς αυτό η αντίθεση του κειμένου
// εξαρτάται από το περιεχόμενο μιας εικόνας, δηλαδή δεν είναι ελέγξιμη.

export function AuthLayout({ title, subtitle, footer, children, width = 'max-w-md' }) {
    // P3-11: οι τέσσερις οθόνες ταυτοποίησης ζουν **έξω** από το κέλυφος, οπότε δεν
    // περνούν από την κεφαλίδα που γράφει τον τίτλο για όλες τις υπόλοιπες. Ο
    // τίτλος που ήδη δείχνει η κάρτα είναι ο ίδιος που πάει στην καρτέλα.
    useDocumentTitle(title);

    return (
        <div
            className="relative flex min-h-screen items-center justify-center bg-purple-950 bg-cover bg-center px-4 py-10"
            style={{ backgroundImage: `url(${bckImg})` }}
        >
            <div className="absolute inset-0 bg-purple-950/70" aria-hidden="true" />

            <Card className={`relative w-full ${width} gap-4`}>
                <div className="flex flex-col items-center gap-3">
                    <img src={logo} alt="" className="h-14 w-auto" />
                    <h1 className="text-center text-xl font-bold">{title}</h1>
                    {subtitle && <p className="text-center text-sm text-muted">{subtitle}</p>}
                </div>

                {children}

                {footer && (
                    <>
                        <hr className="border-t border-border" />
                        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm">{footer}</div>
                    </>
                )}
            </Card>
        </div>
    );
}

/** Ο σύνδεσμος του υποσέλιδου, με το ίδιο στυλ στις τέσσερις οθόνες. */
export function AuthLink({ to, children }) {
    return (
        <Link
            to={to}
            className="rounded-full px-1 font-medium text-accent underline decoration-accent/40 underline-offset-4 hover:decoration-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
        >
            {children}
        </Link>
    );
}

export default AuthLayout;
